import { CLEAR_FAVORITE_COLLECTION, FETCH_FAVORITE_COLLECTION, SET_FAVORITE_COLLECTION } from "../actions";

const initialState = {
    favoriteCollectionData: null,
    isLoading: false,
    error: null,
};

const favoriteCollectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FAVORITE_COLLECTION:
            return { ...state, isLoading: true, error: null };

        case SET_FAVORITE_COLLECTION:
            return { ...state, favoriteCollectionData: action.payload, isLoading: false, error: null };

        case CLEAR_FAVORITE_COLLECTION:
            return { ...state, favoriteCollectionData: null, isLoading: false, error: null };

        default:
            return state;
    }
};

export default favoriteCollectionReducer;
